import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useEPMContext } from '../../../contexts/EPMContext';
import { toast } from 'react-toastify';
import TestOverview from '../TestOverview';
import Button from '../../UI/Button/Button';

const TestDetails = () => {
    const { id: testId } = useParams();
    const { fetchTestById } = useEPMContext();
    const [testData, setTestData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchDetails = async () => {
            setIsLoading(true);
            try {
                const data = await fetchTestById(testId);
                setTestData(data);
            } catch (err) {
                toast.error("Failed to load test details.");
                navigate('/epm/testing-board');
            } finally {
                setIsLoading(false);
            }
        };
        fetchDetails();
    }, [testId, fetchTestById, navigate]);

    const handleCopyLink = () => {
        const link = `${window.location.origin}/epm/test/details/${testId}`;
        navigator.clipboard.writeText(link);
        toast.success("Link copied to clipboard!");
    };

    if (isLoading) {
        return (
            <div className="p-10 w-full flex justify-center items-center h-64">
                <span className="text-zinc-500">Loading test details...</span>
            </div>
        );
    }

    if (!testData) return null;

    return (
        <div className="stride-page-shell min-w-0">
            <div className="w-full focus:outline-none pb-12">
                <TestOverview
                    testData={testData}
                    setTestData={setTestData}
                    variant="page"
                    actions={
                        <Button variant="secondary" size="xs" onClick={handleCopyLink}>Copy link</Button>
                    }
                />
            </div>
        </div>
    );
};

export default TestDetails;
